import React from 'react'
import s from './index.module.scss'

const Loader = () => {
	return (
		<div className={s.wrapper}>
			<div className={s.loader}>
				<div />
				<div />
				<div />
				<div />
			</div>
		</div>
	)
}

export default Loader
